export enum FreelancerActivityReportStatus {
  Closed = 'Closed',
  Opened = 'Opened',
  Submitted = 'Submitted',
}
